<template>
    <modal @close="$emit('close')" :autoshow="true" ref="modal" :is-closeable="isCloseable">
        <template #title>Update E-Verify Case</template>

        <slot>
            <div>
                <form @submit.prevent="onSubmit()">
                    <p>
                        Set this Onboarding's E-Verify Case to the following:
                    </p>

                    <form-errors :errors="formErrors"/>

                    <div class="form-row">
                        <div class="col">
                            <form-input label="Case Number" v-model="formData.case_number" :errors="errors.case_number" type="text" />
                        </div>
                    </div>
                </form>
            </div>
        </slot>

        <template #footer>
            <div class="form-row mt-2">
                <div class="col">
                    <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Cancel</button>
                </div>
                <div class="col">
                    <button type="submit" class="btn btn-block btn-primary" @click.prevent="onSubmit">Update Case</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import api from '@/api'
import ModalMixin from '@/mixins/ModalMixin'
import FormMixin from '@/mixins/Form'
import moment from 'moment'

export default {
    mixins: [ModalMixin, FormMixin],
    props: ['client', 'employee', ],
    data() {
        const data = {
            formRules: {
                case_number: {presence: {allowEmpty: false}},
            },
            formData: this.makeFormData(),
        }

        return data
    },
    methods: {
        makeFormData() {
            const formData = {
                case_number: '',
            }

            return formData
        },

        onSubmit(evt) {
            const url = `/admin/onboarding-applications/${this.employee.id}/set-everify-case`;
            this.$store.dispatch('START_LOADING')
            this.$api.post(url, this.getFormData()).then(() => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showInfo("Updating", "Updated case.")
                this.$emit('close')
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
    }
}
</script>
